import React from 'react';
// import { ReactComponent as CheckedIcon } from 'assets/icons/checked.svg';
import { Card, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { FormattedMessage } from 'react-intl';

import { useStyles } from './TemplateCard.styles';
import { TemplateCardProps } from './TemplateCard.types';
import { Button } from 'shared/components';
// import { EditTemplateModal } from './editTemplateModal/EditTemplateModal';
import { useLocale } from 'shared/hooks';
// import { TemplatePreviewModal } from './templatePreviewVideoModal/TemplatePreviewVideoModal';

export const TemplateCard = ({ name, image, selected = false }: TemplateCardProps) => {
  const styles = useStyles({ selected });
  const { formatMessage } = useLocale();

  return (
    <>
      <Card className={styles.templateCardContainer}>
        {image ? (
          <img src={image || ''} className={styles.imageContainer} alt="templateImage" />
        ) : (
          <Skeleton height={246} style={{ transform: 'none' }} animation="wave" />
        )}
        {name ? (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography className={styles.title}>
              <FormattedMessage
                id="studentSelection.selection.matching.percentage"
                values={{
                  name: <span className={styles.bold}>{name}</span>,
                }}
              />
            </Typography>
            <div style={{ padding: '5px' }}>
              <Button className={styles.buttonText}>
                {formatMessage({ id: 'studentSelection.clip.edit.template.button' })}
              </Button>
            </div>
          </div>
        ) : (
          <Skeleton height={20} width="80%" animation="wave" />
        )}
      </Card>
    </>
  );
};
